import { apiClient } from "../config/api.client";
import { PUBLIC_BANNERS } from "../constants/api.constant";

export const getPublicBanners = async () => {
    try {
        const { data } = await apiClient.get(PUBLIC_BANNERS);
        return data;
    } catch (error) {
        console.log("Error Fetching Public Banners :", error);
        throw error;
    }
};


